import * as apiUtils from "./apiUtils";

const baseUrl = process.env.API_URL;

//{
//   PortalId: 2, // int
//   CountryId: 1, // int
//   BrandIdentifier: LifeSafer, // String
//   IncludeTest: false, // bool
// }
export function getStates(params) {
  return apiUtils
    .get(
      `${baseUrl}/DataList/GetStates?PortalId=${params.PortalId}` +
        `&CountryId=${params.CountryId}` +
        `&BrandIdentifier=${params.BrandIdentifier}` +
        `&IncludeTest=${params.IncludeTest}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getProgramTypes(UserID, StateOfConviction) {
  return apiUtils
    .get(
      `${baseUrl}/DataList/GetProgramTypes?StateOfConviction=${StateOfConviction}&UserID=${UserID}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getCountries() {
  return apiUtils
    .get(`${baseUrl}/DataList/GetCountries`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getRegionId() {
  return apiUtils
    .get(`${baseUrl}/DataList/GetRegionId`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getRegionsByRegionId(regionId) {
  return apiUtils
    .get(`${baseUrl}/DataList/GetRegions?regionId=${regionId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getRegionIdbyName(searchObj) {
  return apiUtils
    .get(
      `${baseUrl}/DataList/GetRegionId?regionTypeId=${searchObj.regionTypeId}&description=${searchObj.description}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}


